export default __webpack_public_path__ + "static/media/LandRoverBG.577e5d30.png";